<template>
    <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown" mode="in-out">
        <div class="subscribe-bot">
            <div class="text-right">
                <a href="#" class="close" @click="$emit('close')"  style="margin-right:25px;margin-top:15px;color:white;opacity:0.7"><span aria-hidden="true">&times;</span></a>
            </div>
            <br>

            <div class="text-center" v-if="pagelist.length == 0 " style="margin-top:45px;">
                <h2 class="title">YOU DON'T HAVE ANY FACEBOOK PAGE</h2>

                <div class="text-center" style="max-width: 300px;margin: 35px auto;">
                    <img src="/static/img/assets/bot/robot_crying@4x.png" alt="" class="img-responsive">
                </div>

                <a href="https://www.facebook.com/pages/creation/" class="btn btn-facebook btn-lg" style="margin-top:35px;">
                   <i class="fa fa-facebook-official middle"></i> Go to create new facebook page
                </a>
            </div>
            <template v-else>
                <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut" mode="out-in">
                    <div class="subscribe-bot-transition page-list" v-if="currentView=='pageList'" key="pageList">
                        <div class="text-center">
                            <h2 class="title" style="margin-top: 35px">Select your Facebook Page to install 
                                <template v-if="themelist.length > 0">
                                    <span>{{themelist[0].themename}}</span>
                                    
                                </template>
                            </h2>                        
                        </div>

                        <div class="pages" style="max-width: 300px;margin: auto;margin-bottom: 25px;">
                            <div class="row">
                                <page-item v-for="(page ,index) in pagelist" :key="'page_'+index" @onPageClick="onSelectedPage(page)" v-model="pagelist[index]"></page-item>
                            </div>
                        </div>
                    </div>
                    <div class="subscribe-bot-transition summary" v-else key="summary">
                        <div class="text-center">
                            <h2 class="title" style="margin-top: 35px">Chatbot will be installed to</h2>

                            <div class="selected-page">
                                <img :src="'https://graph.facebook.com/'+ selectedPage.id +'/picture?width=200&height=200'" alt="">
                                <h3>{{ selectedPage.name }}</h3>
                                <p style="color:rgba(255,255,255,0.5)">{{ selectedTheme.themename }}</p>
                            </div>
                            
                            <checkbox v-model="isStart">
                                Start your bot after install
                            </checkbox>
                            <div style="margin-top:25px;">
                                <a href="javascript:void(0);" class="btn btn-default btn-lg transparent" @click="currentView = 'pageList'" style="margin-right: 10px">Back</a>
                                <a href="javascript:void(0);" class="btn btn-primary btn-lg" @click="onSubscribeBot">Start</a>
                            </div>

                        </div>
                    </div>
                </transition>
            </template>

        </div>
    </transition>
</template>

<script>
import api from '@/api'
import config from '@/config'
import Checkbox from '@/components/elements/Checkbox'
import PageItem from './PageItem'
import { mapGetters, mapMutations } from 'vuex'
    export default {
        props: ['themes'],
        data: function(){
            return {
                selectedTheme: null,
                themelist: this.themes,
                selectedPage: null,
                currentView: 'pageList',
                isStart: false
            }
        },
        components: {
            Checkbox,
            PageItem
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot',
                botlist: 'botlist',
                pagelist: 'unsubscribedPage',
            }),
        },
        methods: {
            onSelectedPage: function(page){
                this.selectedPage = page
                this.selectedTheme = this.themelist[0]
                this.currentView = 'summary'
            },
            onSubscribeBot: function(){
                if (this.selectedPage == null || this.selectedTheme == null) {
                    return
                }
                let vm = this
                let page = this.selectedPage
                let data = {
                    pageid : page.id,
                    page_access_token : page.access_token,
                    theme : this.selectedTheme.themeid,
                    pagename : page.name,
                    ownerid : this.$store.state.userid,
                    status : this.isStart
                }
                vm.$store.dispatch('loading')
                vm.$store.dispatch('addModalWelcome')
                api.newSubscribe(data, function(error, response){
                    if (error) {
                        console.error(error)
                        vm.$store.dispatch('loading')
                        return
                    }

                    $('#modal_subscribe_bot').modal('hide')

                    
                    vm.$store.dispatch('updateNewBotlist').then(
                    function(){
                        var bot = null
                        $.each(vm.botlist,function(index,val){
                            if (val.pageid == page.id) {
                                bot = val
                                return false
                            }
                        })
                        if (bot != null) {
                            
                            vm.$store.dispatch('selectBot',bot)
                            vm.$store.dispatch('loading')
                            vm.$router.push("/chatbot")
                        } else {
                            vm.selectedPage = ''
                            vm.selectedTheme = ''
                            vm.isStart = false

                            vm.$emit('close')
                            vm.$store.dispatch('loading')
                        }
                    }, function(error){
                        vm.selectedPage = ''
                        vm.selectedTheme = ''
                        vm.isStart = false

                        vm.$emit('close')
                        vm.$store.dispatch('loading')
                        vm.errorMessage = 'Can not update chatbot'
                    })

                    
                    
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/allbots/SubscribeBot.vue